import { fetchPendingInvoices } from '../../actions'
import { fetchAccountBalance } from '../../../Account/actions'
import { fetchPaidInvoices } from '../../../PaidInvoices/actions'
import moment from 'moment'

function refreshEditPendingInvoice(){
  return (dispatch, getState) => {
    const { editPendingInvoiceForm, organization, resident } = getState()
    const { id } = editPendingInvoiceForm

    $.ajax({
      url: `/organizations/${organization.name}/invoices/${id}.json`,
      success: payload => {
        dispatch({ type: 'REFRESH_EDIT_PENDING_INVOICE', payload })
      }
    })
  }
}

export function refundCharge(charge_id){
  return (dispatch, getState) => {
    const { organization } = getState()
    dispatch({type:'BEGIN_REFUND_CHARGE'})
    $.ajax({
      url: `/organizations/${organization.name}/charges/${charge_id}/refund.json`,
      method: 'PATCH',
      success: response => {
        dispatch(fetchPendingInvoices())
        dispatch(refreshEditPendingInvoice())
        dispatch(fetchAccountBalance())
        dispatch(fetchPaidInvoices())
      }
    })
  }
}

export function updatePendingInvoice(){
  return (dispatch, getState) => {
    const { organization, resident, editPendingInvoiceForm } = getState()
    const { id, email, description, amount, due_days_after_invoice } = editPendingInvoiceForm
    
    dispatch({type:'BEGIN_SUBMIT_UPDATE_PENDING_INVOICE'})
    $.ajax({
      url: `/organizations/${organization.name}/invoices/${id}.json`,
      method: 'PATCH',
      data: {
        invoice: {
          email,
          description,
          amount,
          due_days_after_invoice,
        }
      },
      success: (response) => {
        dispatch(fetchPendingInvoices())
        dispatch(fetchPaidInvoices())
        dispatch({type:'SUCCESS_SUBMIT_UPDATE_PENDING_INVOICE'})
      },
      error: (xhr) => {
        var errors = $.parseJSON(xhr.responseText).errors
        dispatch({ type:'FAILED_SUBMIT_UPDATE_PENDING_INVOICE', payload: errors })
      }
    })
  }
}

export function deletePendingInvoice(){
  return (dispatch, getState) => {
    const { organization, resident, editPendingInvoiceForm } = getState()
    const { id } = editPendingInvoiceForm
    
    dispatch({type:'BEGIN_SUBMIT_DELETE_PENDING_INVOICE'})
    $.ajax({
      url: `/organizations/${organization.name}/invoices/${id}.json`,
      method: 'DELETE',
      success: (response) => {
        dispatch(fetchPendingInvoices())
        dispatch(fetchPaidInvoices())
        dispatch({type:'SUCCESS_SUBMIT_DELETE_PENDING_INVOICE'})
      },
      error: (xhr) => {
        var errors = $.parseJSON(xhr.responseText).errors
        dispatch({type:'FAILED_SUBMIT_DELETE_PENDING_INVOICE', payload: errors})
      }
    })
  }
}